import { submittedToUrlParamsTranslation } from "@/globalConsts/submittedToUrlParamTranslation";

export type SearchParams = {
  [index: string]: string;
};

export function pushUrlSearchParams(params: SearchParams): void {
  // We have to clean the URL before overwriting with submitted query
  replaceState(window.location.pathname);

  let url = new URL(window.location.href);
  url = setSearchParams(url, params);

  replaceState(decodeURIComponent(url.toString()));
}

function replaceState(url: string): void {
  window.history.replaceState({}, "", url);
}

function setSearchParams(url: URL, queries: SearchParams): URL {
  Object.keys(queries).forEach((key) => {
    const searchQueryValue = queries[key];

    if (key !== undefined && searchQueryValue) {
      url.searchParams.set(key, searchQueryValue);
    }
  });

  return url;
}

export function getCurrentSearchParams(): SearchParams {
  const search = window.location.search.substring(1);
  const urlParams = new URLSearchParams(search);

  return Object.fromEntries(urlParams);
}

export function addSearchParams(
  key: string,
  searchParams: SearchParams,
  minValue?: number,
  maxValue?: number,
  delimiter = ","
): SearchParams {
  searchParams[submittedToUrlParamsTranslation[key]] =
    minValue && maxValue ? `${minValue}${delimiter}${maxValue}` : "";

  return searchParams;
}

export function deleteSearchParam(searchParamKey: string): void {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(searchParamKey);

  pushUrlSearchParams(Object.fromEntries(searchParams));
}
